<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="节假日" prop="holiday_name">
        <Input v-model="formValidate.holiday_name" placeholder="请输入节假日"></Input>
      </FormItem>

      <FormItem label="祝福语" prop="greetings">
        <Input v-model="formValidate.greetings" placeholder="请输入祝福语"></Input>
      </FormItem>

      <FormItem label="所属分类"  prop="classify" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import {getClassifyTag} from "@/api/data";
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      formValidate: {
        id: '',
        holiday_name: '',
        greetings:'',
        classify:0
      },
      ruleValidate: {
        holiday_name: [
          {
            required: true,
            message: '节假日不能为空',
            trigger: 'blur'
          }
        ],
        greetings: [
          {
            required: true,
            message: '祝福语不能为空',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.classify = data.classify_id.toString()
      this.formValidate.holiday_name = data.holiday_name
      this.formValidate.greetings = data.greetings
    },

    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
